import React from 'react'
import Button from 'src/components/common/Button'
import styles from './purchase-on-mobile.scss'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { branchFloatingButtonLinkSelector } from '../../../selectors'
import { routerActions } from 'react-router-redux'
import { setCheckoutModalOpen } from 'src/actions/stripeCheckout'

class PurchaseOnMobile extends React.Component {
  handlePurchaseCredits = () => {
    const { changePurchaseCredits, closeModal } = this.props

    closeModal()
    changePurchaseCredits()
  }

  render() {
    const requiredCredits = this.props.params?.requiredCredits

    return (
      <main className={styles['main-container']}>
        <header>
          {this.props.title && <h1>{this.props.title}</h1>}
          {!this.props.title && <h1>Unsent Invites</h1>}
        </header>
        <section>
          {!!requiredCredits && (
            <p>
              Looks like you need {requiredCredits} more credits to finish sending your invites.
            </p>
          )}
          <p>Please upgrade your plan on Hobnob app. </p>
        </section>
        <footer className={styles['footer-container']}>
          <Button wrapperElement={'a'} href={this.props.appLink}>
            Get Hobnob App
          </Button>
          {!!requiredCredits && (
            <Button onClick={this.handlePurchaseCredits}>Purchase Credits</Button>
          )}
        </footer>
      </main>
    )
  }
}

PurchaseOnMobile.propTypes = {
  title: PropTypes.string,
  params: PropTypes.object,
  appLink: PropTypes.string,
  changePurchaseCredits: PropTypes.func,
  closeModal: PropTypes.func
}

const mapStateToProps = state => {
  return {
    appLink: branchFloatingButtonLinkSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changePurchaseCredits: () => dispatch(routerActions.push('/purchase-credits')),
    closeModal: () => dispatch(setCheckoutModalOpen(false))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOnMobile)
